export default (state, nextState) => ({
    byId: {
        ...state.byId,
        ...nextState.byId,
    },
    allIds: [...new Set([...state.allIds, ...nextState.allIds])],
});
